import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from '../../screen/Home';
import Contact from '../../screen/Contact';
import Services from '../../screen/Service';
import Course from '../../screen/Course';
import About from '../../screen/About';
import DataOne from '../../screen/Data_one';
import DataTwo from '../../screen/Data_two';

export default function Navigation() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route
					path="/computer-coaching-center-in-nelamangala"
					element={<Home />}
				/>
				<Route path="/Contact" element={<Contact />} />
				<Route path="/Service" element={<Services />} />
				<Route path="/Course" element={<Course />} />
				<Route path="/About" element={<About />} />
				<Route path="/data" element={<DataOne />} />
				<Route path="/data_two" element={<DataTwo />} /> 
			</Routes>
		</Router>
	);
}
